import React, { Component } from 'react';
import { AgGridReact } from "@ag-grid-community/react";
import { Loader } from 'semantic-ui-react';
import { ACTION_STATUS } from '../../../../../utils/ActionStatus';


class ElementTypeMngGrid extends Component {

    constructor(props) {
        super(props);
        const that = this;
        this.state = {
            columnDefs: [
                {field: 'baseType', headerName: 'baseType', cellClass: 'non-number', width: 150, checkboxSelection: true, cellRenderer: 'agGroupCellRenderer' },
                {field: 'elementTypeName', headerName: 'elementTypeName', cellClass: 'non-number', width: 200 },
                {field: 'shape', headerName: 'shape', cellClass: 'non-number', width: 150 },
                {field: 'color', headerName: 'color', cellClass: 'non-number', width: 150 },
                {field: 'createTime', headerName: 'createTime', cellClass: 'non-number', width: 150 },
                {field: 'createdBy', headerName: 'createdBy', cellClass: 'non-number', width: 150 },
                {field: 'updateTime', headerName: 'updateTime', cellClass: 'non-number', width: 150 },
                {field: 'updatedBy', headerName: 'updatedBy', cellClass: 'non-number', width: 150 },
            ],
            defaultColDef: {
                enableCellChangeFlash: true,
                minWidth: 50,
            },
            rowSelection: 'single',
            context: { componentParent: this },

            detailCellRendererParams: {
                detailGridOptions: {
                    columnDefs:[
                        {headerName: '', cellClass: 'non-number', width: 50, checkboxSelection: this.fieldCheckBoxSelection},
                        {field: 'isConstraint', headerName: 'isConstraint', cellClass: 'non-number', width: 120},
                        {field: 'fieldName', headerName: 'fieldName', cellClass: 'non-number', width: 200 },
                        {field: 'createTime', headerName: 'createTime', cellClass: 'non-number', width: 150 },
                        {field: 'createdBy', headerName: 'createdBy', cellClass: 'non-number', width: 150 },
                        {field: 'updateTime', headerName: 'updateTime', cellClass: 'non-number', width: 150 },
                        {field: 'updatedBy', headerName: 'updatedBy', cellClass: 'non-number', width: 150 },
                    ],
                    rowSelection: 'single',
                    suppressRowClickSelection: true,
                    suppressAggFuncInHeader: true,
                    enableColResize: true,
                    enableSorting: true,
                    enableFilter: true,
                    animateRows: true,
                    deltaRowDataMode: false,
                    isRowSelectable: this.fieldCheckBoxSelection,
                    onSelectionChanged(node) {
                        const rowNodeArray = node.api.getSelectedNodes();
                        let elementTypeFieldList = rowNodeArray.map(e => e.data);
                        that.props.selectElementTypeFieldList(elementTypeFieldList);
                    },

                },

                getDetailRowData: function(params) {
                    params.successCallback(params.data.elementTypeFieldList);
                },
                getRowNodeId: function(data) {
                    return data.id;
                },
                template:
                '<div style="height: 100%; background-color: #edf6ff; padding: 20px; box-sizing: border-box;">' +
                '  <div style="height: 10%; margin-bottom: 10px; font-weight: bold;">Fields</div>' +
                '  <div ref="eDetailGrid" style="height: 90%;"></div>' +
                "</div>"
            },

        };
    }


    fieldCheckBoxSelection = (node) => {
        return node.data.isConstraint === 'N';
    }



    getRowNodeId = data => {
        return data.id;
    };


    onSelectionChanged = (node) => {
        let rowNodeArray = node.api.getSelectedNodes();
        let elementTypeList = rowNodeArray.map(rowNode => rowNode.data);
        this.props.selectElementTypeList(elementTypeList);
    }



    render() {
        const {
            queryElementTypeActionStatus,
            queryElementTypeActionResp,
        } = this.props;

        const isLoading = queryElementTypeActionStatus === ACTION_STATUS.LOGINING;

        let presentDataArray = [];
        if(!!queryElementTypeActionResp && !!queryElementTypeActionResp.data) {
            presentDataArray = queryElementTypeActionResp.data;
        }


        return (
            <div className={'ag-theme-balham grid-wrapper'}>
                {isLoading ? (
                        <Loader active content="Loading..." />
                    ) : (
                        <AgGridReact
                            // properties
                            columnDefs={this.state.columnDefs}
                            rowData={presentDataArray}
                            defaultColDef={this.state.defaultColDef}
                            rowSelection={this.state.rowSelection}
                            suppressRowClickSelection={true}
                            suppressAggFuncInHeader={true}
                            enableSorting={true}
                            enableFilter={true}
                            animateRows={true}
                            deltaRowDataMode={false}
                            enableColResize={true}
                            getRowNodeId={this.getRowNodeId}
                            context={this.state.context}
                            // master/detail
                            masterDetail={true}
                            detailCellRendererParams={this.state.detailCellRendererParams}
                            // event
                            onSelectionChanged={this.onSelectionChanged}
                        />
                    )}
            </div>
        );
    }

}

export default ElementTypeMngGrid;

